import { useState, useCallback } from 'react';
import tenantConstants from '@constants';
import { CAPTCHA_TOKEN_KEY } from '../constants/constants';

export const useCaptcha = () => {
  const [captchaSolved, setCaptchaSolved] = useState(false);

  const isCaptchaRequired = tenantConstants.CAPTCHA_CONFIG?.enableWithKCOtpEndpoints;
  const shouldShowCaptcha = isCaptchaRequired && !captchaSolved;
  const shouldShowContent = !isCaptchaRequired || captchaSolved;

  const checkCaptchaToken = useCallback(
    (onNoToken, onHasToken) => {
      if (isCaptchaRequired) {
        const captchaToken = localStorage.getItem(CAPTCHA_TOKEN_KEY);
        if (!captchaToken) {
          if (onNoToken) onNoToken();
          return false;
        }
      }
      if (onHasToken) onHasToken();

      return true;
    },
    [isCaptchaRequired],
  );

  const handleCaptchaSuccess = useCallback((onSuccess) => {
    setCaptchaSolved(true);
    if (onSuccess) {
      onSuccess();
    }
  }, []);

  const resetCaptcha = useCallback(() => {
    setCaptchaSolved(false);
  }, []);

  const resetCaptchaAndTrigger = useCallback((onReset) => {
    setCaptchaSolved(false);
    if (onReset) {
      onReset();
    }
  }, []);

  return {
    captchaSolved,
    isCaptchaRequired,
    shouldShowCaptcha,
    shouldShowContent,
    checkCaptchaToken,
    handleCaptchaSuccess,
    resetCaptcha,
    resetCaptchaAndTrigger,
  };
};

export default useCaptcha;
